import xhr from '../xhr';

const argsToFormData = args => {
    const formData = new FormData;
    for(const name in args)
        formData.append(name, args[name]);

    return formData;
};

export async function getCategory(name) {
    if(typeof name !== 'string' || name.trim() === '')
        throw new Error('name is not a valid category name');

    const { status, body } = await xhr.get(
        `/comments/categories/${name}`,
        { type: 'json' }
    );
    if(status !== 200)
        throw new Error(body.error?.text ?? 'something went wrong', { cause: body.error?.name ?? 'something' });

    return body;
};

export async function updateCategory(name, args) {
    if(typeof name !== 'string' || name.trim() === '')
        throw new Error('name is not a valid category name');
    if(typeof args !== 'object' || args === null)
        throw new Error('args must be a non-null object');

    const { status, body } = await xhr.post(
        `/comments/categories/${name}`,
        { csrf: true, type: 'json' },
        args
    );
    if(status !== 200)
        throw new Error(body.error?.text ?? 'something went wrong', { cause: body.error?.name ?? 'something' });

    return body;
};

export async function getPost(post) {
    if(typeof post !== 'string' || post.trim() === '')
        throw new Error('post is not a valid post id');

    const { status, body } = await xhr.get(
        `/comments/posts/${post}`,
        { type: 'json' }
    );
    if(status !== 200)
        throw new Error(body.error?.text ?? 'something went wrong', { cause: body.error?.name ?? 'something' });

    return body;
};

export async function getPostReplies(post) {
    if(typeof post !== 'string' || post.trim() === '')
        throw new Error('post is not a valid post id');

    const { status, body } = await xhr.get(
        `/comments/posts/${post}/replies`,
        { type: 'json' }
    );
    if(status !== 200)
        throw new Error(body.error?.text ?? 'something went wrong', { cause: body.error?.name ?? 'something' });

    return body;
};

export async function createPost(args) {
    if(typeof args !== 'object' || args === null)
        throw new Error('args must be a non-null object');

    const { status, body } = await xhr.post(
        '/comments/posts',
        { csrf: true, type: 'json' },
        argsToFormData(args)
    );
    if(status !== 201)
        throw new Error(body.error?.text ?? 'something went wrong', { cause: body.error?.name ?? 'something' });

    return body;
};

export async function updatePost(post, args) {
    if(typeof post !== 'string' || post.trim() === '')
        throw new Error('post is not a valid post id');
    if(typeof args !== 'object' || args === null)
        throw new Error('args must be a non-null object');

    const { status, body } = await xhr.patch(
        `/comments/posts/${post}`,
        { csrf: true, type: 'json' },
        argsToFormData(args)
    );
    if(status !== 200)
        throw new Error(body.error?.text ?? 'something went wrong', { cause: body.error?.name ?? 'something' });

    return body;
};

export async function deletePost(post) {
    if(typeof post !== 'string' || post.trim() === '')
        throw new Error('post is not a valid post id');

    const { status, body } = await xhr.delete(`/comments/posts/${post}`, { csrf: true, type: 'json' });
    if(status !== 204)
        throw new Error(body.error?.text ?? 'something went wrong', { cause: body.error?.name ?? 'something' });
};

export async function restorePost(post) {
    if(typeof post !== 'string' || post.trim() === '')
        throw new Error('post is not a valid post id');

    const { status, body } = await xhr.post(`/comments/posts/${post}/restore`, { csrf: true, type: 'json' });
    if(status !== 200)
        throw new Error(body.error?.text ?? 'something went wrong', { cause: body.error?.name ?? 'something' });
};

export async function nukePost(post) {
    if(typeof post !== 'string' || post.trim() === '')
        throw new Error('post is not a valid post id');

    const { status } = await xhr.post(`/comments/posts/${post}/nuke`, { csrf: true, type: 'json' });
    if(status !== 200)
        throw new Error(body.error?.text ?? 'something went wrong', { cause: body.error?.name ?? 'something' });
};

export async function createVote(post, vote) {
    if(typeof post !== 'string' || post.trim() === '')
        throw new Error('post is not a valid post id');
    if(typeof vote === 'string')
        vote = parseInt(vote);
    if(typeof vote !== 'number' || isNaN(vote))
        throw new Error('vote must be a number');

    const { status, body } = await xhr.post(
        `/comments/posts/${post}/vote`,
        { csrf: true, type: 'json' },
        { vote }
    );
    if(status !== 201)
        throw new Error(body.error?.text ?? 'something went wrong', { cause: body.error?.name ?? 'something' });

    return body;
};

export async function deleteVote(post) {
    if(typeof post !== 'string' || post.trim() === '')
        throw new Error('post is not a valid post id');

    const { status, body } = await xhr.delete(
        `/comments/posts/${post}/vote`,
        { csrf: true, type: 'json' }
    );
    if(status !== 200)
        throw new Error(body.error?.text ?? 'something went wrong', { cause: body.error?.name ?? 'something' });

    return body;
};
